import { IAxiosReturn } from "../interface";
import { TlfBundleExportRequest, TlfBundleTransferProgress } from "./interface";
import { tlfBundleApi } from "./tlfBundleApi";

/**
 * Download a complete compressed bundle and report its byte progress.
 *
 * @param backEndUrl - Backend base URL
 * @param request - Hierarchy and item selection to export
 * @param controller - AbortController for the export request
 * @param onProgress - Optional callback for file download progress
 * @returns Compressed bundle or a standard API failure result
 */
export const exportTlfBundle = async (
  backEndUrl: string,
  request: TlfBundleExportRequest,
  controller: AbortController,
  onProgress?: (progress: TlfBundleTransferProgress) => void,
): Promise<IAxiosReturn<Blob>> => {
  const exportResponse = await tlfBundleApi.createExport(
    backEndUrl,
    request,
    controller,
    (transferredBytes, reportedTotalBytes) => {
      onProgress?.({
        completedChunks: 0,
        totalChunks: 1,
        transferredBytes,
        totalBytes: reportedTotalBytes,
      });
    },
  );
  if (!exportResponse.success) return exportResponse;
  if (controller.signal.aborted) {
    return { success: false, errorText: "Download TLF bundle failed, request cancelled" };
  }

  const bundle = exportResponse.data;
  if (bundle.size === 0) {
    return { success: false, errorText: "The exported TLF bundle is empty" };
  }
  onProgress?.({
    completedChunks: 1,
    totalChunks: 1,
    transferredBytes: bundle.size,
    totalBytes: bundle.size,
  });
  return { success: true, data: bundle };
};
